export default "__VITE_ASSET__Ck23P6p5__"